<template>
    <div class="resultPage">
        <img :src="url" alt="" />
        <!-- <div class="tx">长按保存图片分享</div> -->
        <div @click="downLoadImg" class="tx">点击下载图片</div>
        <div class="share-btn" v-if="show_share" @click="share">
            <img src="../assets/images/share_icon.png" alt="" />
        </div>
    </div>
</template>

<script>
import { ref } from "vue";
import { useRoute  } from "vue-router";
export default {
    setup() {
        const url = ref("")
        const show_share = ref(true)
        url.value = sessionStorage.getItem("shareImg");
        const route = useRoute()
        const query = route.query;
        if(query.info) {
            console.log(JSON.parse(query.info).is_share);
            if (JSON.parse(query.info).is_share) {
                show_share.value = false;
            } else {
                show_share.value = true;
            }
        }
        let device = new MCPDevice();
        const share = () => {
            let options = {
                channel: '0', //分享渠道 '0'-全部(弹窗) '1'-好友 '2'-朋友圈
                title: '工银安盛',    //分享标题
                desc: '生日贺卡点击查看详细',     //分享描述
                link: 'https://icbc-axa-web.sqqmall.com?info=' + query.info,     //分享链接，必传
                imgUrl: 'https://sqqmall-php.oss-cn-shenzhen.aliyuncs.com/icbc-h5/birthday1.jpg'    //分享图标链接
                // imgUrl: 'https://sqqmall-php.oss-cn-shenzhen.aliyuncs.com/icbc-h5/birthday2.jpg'    //分享图标链接
            }; 
            device.shareWeChat(options).then((res) => {
                console.log(res)
            }).catch((err) => {
                //fail
                console.error(err);
            });
        }
        // 下载图片
        const downLoadImg = () => {
            device.downloadImage(url.value).then((res) => {
                //success
                console.log(res)
            }).catch((err) => {
                //fail
                console.error(err);
            });
        }
        return { url, share, show_share, downLoadImg};
    }
}
</script>

<style lang="stylus">
    body {
        background: #f8f8f8;
    }
    .resultPage {
        padding: 30px;
        box-sizing: border-box;
        img {
            font-size: 0;
            width: 100%;
        }
        .tx {
            margin-top: 20px;
            font-size: 28px;
            font-family: OPPOSans, OPPOSans-Regular;
            font-weight: 400;
            text-decoration: underline;
            text-align: center;
            color: #333333;
        }
        .share-btn {
            position: fixed;
            right: 0;
            bottom: 200px;
            img {
            width: 100px;
            height: 100px;
            }
        }
    }
</style>
